import { forwardRef } from "react";

// iter 370kt — golf-cart sidebar icon for Cart Inventory.
//
// Switched to the Material Design Icons "golf-cart" silhouette
// (Apache-2.0, by Michael Richins / Pictogrammers). MDI's path is
// the industry-standard golf-cart icon — solid silhouette with two
// wheels, a passenger compartment, and the visible golf clubs/bag
// sticking up out the back. Renders cleanly down to 14px and reads
// unambiguously as a golf cart at sidebar sizes.
//
// Path source: https://pictogrammers.com/library/mdi/icon/golf-cart/
//
// Filled (fill="currentColor"), not stroked, so width/strokeWidth
// kwargs are accepted for API compatibility with lucide-react but
// ignored. `size` and `className` work the same as any lucide icon.
export const GolfCartIcon = forwardRef(function GolfCartIcon(
  { size = 24, className = "", ...rest },
  ref,
) {
  // Strip any stroke-related lucide-style props the caller may have
  // forwarded — they're meaningless on a filled silhouette.
  const { strokeWidth, stroke, fill, ...passthrough } = rest;
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="none"
      className={`lucide lucide-golf-cart ${className}`.trim()}
      aria-hidden="true"
      {...passthrough}
    >
      <path d="M19.89 12.37L18.25 5H19V3H3V7H1V9H3V12.54A6 6 0 0 0 1 17V19H3A3 3 0 0 0 9 19H15A3 3 0 0 0 21 19H23V17A5 5 0 0 0 19.89 12.37M6 20.5A1.5 1.5 0 1 1 7.5 19A1.5 1.5 0 0 1 6 20.5M15.53 12L14.38 10.28L15.8 9.33L14.7 7.67L10.2 10.67L11.3 12.33L12.73 11.38L13.88 13.12L13 14H10.2L5 7V5H16.2L17.75 12M18 20.5A1.5 1.5 0 1 1 19.5 19A1.5 1.5 0 0 1 18 20.5Z" />
    </svg>
  );
});
